import { NgClass } from '@angular/common';
import { Component, Input } from '@angular/core';
import { RouterLink, RouterLinkActive } from '@angular/router';

import { NgbTooltip } from '@ng-bootstrap/ng-bootstrap';
import { HasRolesDirective } from 'keycloak-angular';

@Component({
    selector: 'console-menu',
    imports: [NgClass, RouterLink, RouterLinkActive, NgbTooltip, HasRolesDirective],
    templateUrl: './console-menu.component.html',
    styleUrls: ['./console-menu.component.scss']
})
export class ConsoleMenuComponent {
  @Input() stretchMenu!: boolean;
  subDesign = false;
  subHealthCheck = false;

  isChildActive(element: any, subMenu: 'subDesign' | 'subHealthCheck'): boolean {
    for (const listElement of element.querySelectorAll('ul.sub_items li')) {
      if (listElement.classList.contains('active')) {
        this[subMenu] = true;
        return true;
      }
    }
    return false;
  }
}
